/*Application types*/
export const SAML2_APPLICATION = "SAML2_APPLICATION";
export const OIDC_APPLICATION = "OIDC_APPLICATION";
export const WS_FEDERATION_APPLICATION = "WS_FEDERATION_APPLICATION";


// WEBPACK FOOTER //
// ./src/constants/applicationTypes.js